export default "__VITE_ASSET__DQEYb_21__"